const scope = 'containers/GlobalExport/';
export const EXPORT_ITEM = `${scope}EXPORT_ITEM`;
export const SET_EXPORT_LOADING_FLAG = `${scope}SET_EXPORT_LOADING_FLAG`;
export const GET_EXPORT_FILE = `${scope}GET_EXPORT_FILE`;

export const FILE_POLLING_DELAY = 1500;
export const MAX_FILE_POLLING_ATTEMPTS = 120;
